import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm, ComPhoto, NoResult, GoodsPhoto } from "../../../js/ComponentManager";
import { AccountMsgDtl } from "./AccountMsgDtl";
import { Link } from 'react-router-dom';

/* 개발담당:양유빈
 * 화면기능:거래처알림리스트
 * 세부설명:
*/

export class AlertMsg extends Component {
    static displayName = AlertMsg.name;

    constructor(props) {
        super(props);
        this.state = {
            Allim_Mgt: [],
            btnDel_Show: false,
            Title: "",
            Content: ""
        };
        this.CsName = Big3Common.ContentState;
        this.Trash = React.createRef();
        this.ref_AccountMsgDtl = React.createRef();
        this.handleLink_Click = this.handleLink_Click.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.CallAlertMsgData();
    }
    handleLink_Click(event, list) {
        let conf_yn = list.conf_yn;
        let alim_cd = list.alim_cd;
        if (conf_yn !== "Y") {
            try {
                let Data =  Big3Common.Get(`api/MyPage/Notice/SetAllmMgtConfYn/${alim_cd}`);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //읽음 처리 후 링크 처리
                    /* this.LinkPageMove(list);*/
                }
            }
            catch (e) {
                console.log("handleLink_Click", e);
            }
        }
        else {
            //링크 처리만 수행
            /*this.LinkPageMove(list);*/
        }
        event.preventDefault();
    }
    //알림 리스트 목록조회 
    async CallAlertMsgData() {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get('api/MyPage/Notice/GetAllmMgtList')
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                this.setState({ Allim_Mgt: DataList });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallAlertMsgData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //Index에서 호출, 삭제 이벤트 처리
    handleTrash_Click(isShow) {
        this.setState({ btnDel_Show: isShow });
    }
    async handleDelete_Click(alim_cd) {
        if (alim_cd === "all") {
            if (this.state.Allim_Mgt.length === 0) {
                this.setState({ Title: "삭제할 내용이 없습니다." });
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
            }
            else {
                Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
            }
        }
        else {
            this.DeleteAllmgt(alim_cd);
        }
    }
    //알람 메세지 삭제
    async DeleteAllmgt(alim_cd) {
        try {
            let Data = await Big3Common.Get(`api/MyPage/Notice/RemoveAllmMgt/${alim_cd}`);
            this.setState({ Title: Data.message });
            Big3Common.ModalAlert(bootstrap, 'AlertBox');
            this.CallAlertMsgData();
            return false;
        }
        catch (e) {
            console.log()
        }
    }
    handle_AccountMsgDtl(event, item) {
        this.ref_AccountMsgDtl.current.initData(item)
        Big3Common.ModalAlert(bootstrap, 'AccountMsgDtl');
        event.preventDefault();
    }
    // 01:주문요청, 02:주문요청,03:주문요청,04:재고문의(채팅),05:재고답변(채팅),06:주문문의(채팅),07:포장완료,08:거래완료,09:-,10:거래승인 요청
    // 11:거래승인 알림,12:클로디공지사항,13:도매 공지사항 알림,14:주문취소(소매->도매),15:주문취소(도매->소매),16:사입매칭,17:관리자요청알림,20:택배정산알림
    Contentrender = (list) => {
        const Alim_Idx = list.alim_idx;
        let LinkUrl = `${list.linkpath}?${list.linkparams}&alim_idx=${Alim_Idx}`;
        if (list.linkparams === "") {
            LinkUrl = `${list.linkpath}?alim_idx=${Alim_Idx}`;
        }
        if (list.linkpath === "") {
            LinkUrl = "";
        }
        if (Alim_Idx === "05" || Alim_Idx === "06" || Alim_Idx === "11" || Alim_Idx === "13" || Alim_Idx === "19") {
            return (
                <>
                    <div className="alert_img">
                        <ComPhoto className="alert_img_in" Photo={list.photo || ""} />
                    </div>
                    <div className="alert_txt">
                        <Link to={LinkUrl} >
                            <div className="alert_title">{list.alim_idx_nm}{list.conf_yn === "Y" ? "" : <p className="new"></p>}</div>
                            <div className="shop_name">{list.contentfld1}</div>
                            <div className="alert_detail">{list.contentfld2}</div>
                            <div className="alert_time">{list.wrtday}</div>
                        </Link>
                    </div>
                </>
            )
        }
        else if (Alim_Idx === "09") {
            return (
                <>
                    <div className="alert_img">
                        <GoodsPhoto
                            className="alert_img_in"
                            ImageSrc={list.alarm_img || ""}
                        />
                    </div>
                    <div className="alert_txt">
                        <Link to={LinkUrl} >
                            <div className="shop_name2">{list.alim_idx_nm}{list.conf_yn === "Y" ? "" : <p className="new"></p>}</div>
                            <div className="shop_name">{list.contentfld1}</div>
                            <div className="shop_name">{list.contentfld2}</div>
                            <div className="shop_name">{list.contentfld3}</div>
                            <div className="alert_time">{list.wrtday}</div>
                        </Link>
                    </div>
                </>
            )
        }
        else if (Alim_Idx === "07" || Alim_Idx === "15") {
            return (
                <>
                    <div className="alert_img">
                        <GoodsPhoto
                            className="alert_img_in"
                            ImageSrc={list.alarm_img || ""}
                        />
                    </div>
                    <div className="alert_txt">
                        <Link to={LinkUrl} >
                            <div className="shop_name2">{list.alim_idx_nm}{list.conf_yn === "Y" ? "" : <p className="new"></p>}</div>
                            <div className="shop_name">{list.contentfld1}</div>
                            <div className="shop_name">{list.contentfld2}</div>
                            <div className="shop_name">금 액: {list.contentfld3}원</div>
                            <div className="alert_time">{list.wrtday}</div>
                        </Link>
                    </div>
                </>
            )
        }
        else if (Alim_Idx === "20") {
            return (
                <>
                    <div>
                        <div className="alert_img">
                            <div className="alert_img_in"></div>
                        </div>
                    </div>
                    <div className="alert_txt" onClick={(e) => { this.handle_AccountMsgDtl(e, list.alim_cd) }}>
                        <div className="shop_name2">{list.alim_idx_nm}{list.conf_yn === "Y" ? "" : <p className="new"></p>}</div>
                        <div className="shop_name">{list.contentfld1}</div>
                        <div className="alert_detail">{list.contentfld2}</div>
                        <div className="alert_time">{list.wrtday}</div>
                    </div>
                </>
            )
        }
        else {
            return (
                <>
                    <div>
                        <div className="alert_img">
                            <div className="alert_img_in"></div>
                        </div>
                    </div>
                    <div className="alert_txt">
                        <div className="alert_title">{list.alim_idx_nm}{list.conf_yn === "Y" ? "" : <p className="new"></p>}</div>
                        <div className="shop_name">제목: {list.contentfld1}</div>
                        <div className="alert_detail">내용: {list.contentfld2}</div>
                        <div className="alert_time">{list.wrtday}</div>
                    </div>
                </>
            )
        }
       
    }
    //메세지 리스트 랜더링
    Messagerender() {
        const DataList = this.state.Allim_Mgt;
        return (
            <>
                {
                    DataList.map((list) =>
                        <div className="alert_content no_title" key={list.alim_cd} onClick={(e) => this.handleLink_Click(e, list)}>
                            {this.Contentrender(list) }
                            {this.state.btnDel_Show === true ? <div className="alert_delete" onClick={(e) => this.handleDelete_Click(list.alim_cd)}></div> : ""}
                        </div>
                    )}
            </>
        );
    }
    render() {
        const Messagerender = this.Messagerender();
        return (
            <div>
                <div className="tap_box">
                    <div className="n_tap"><div className="alert_tap tap_on">거래처</div></div>
                    <div className="n_tap"><div className="alert_tap" onClick={() => { this.props.RenderComponent('ClodMsg')} } >Clo:D공지</div></div>
                </div>
                <div className="container_box a_margin d_padding">
                    {this.state.btnDel_Show === true ?
                        <div className="delete_box">
                            <button type="button" className="delete_button" onClick={(e) => this.handleDelete_Click('all')} >전체삭제</button>
                        </div>
                        : ""
                    }
                    {Messagerender }
                </div>
                <Alert
                    id="AlertBox"
                    title={this.state.Title}
                />
                <Confirm
                    id="ConfirmBox"
                    title="삭제알림"
                    content="정말로 전체 메세지를 삭제하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);

                        this.DeleteAllmgt('all');
                    }}
                />
                <NoResult
                    Visible={this.state.Allim_Mgt.length === 0 ? true : false}
                    Top={"50%"}
                />
                <AccountMsgDtl
                    id="AccountMsgDtl"
                    ref={this.ref_AccountMsgDtl}
                />
            </div>
        );
    }
}
